import 'uikit/dist/js/uikit.min'
import 'uikit/dist/css/uikit.min.css'
import 'aos/dist/aos.css'
import './config/axios-config'
import Vue from 'vue'
import router from './router'
import App from './App'
import { i18n } from './i18n'
import store from './store'
import AOS from 'aos'

AOS.init()

Vue.config.productionTip = false

Vue.mixin({
  data: function () {
    return {
      ASSETS_BASE_URL: process.env.VUE_APP_ASSETS_BASE_URL
    }
  }
})

new Vue({
  render: h => h(App),
  router,
  i18n,
  store
}).$mount('#app')
